import React from 'react'
import { FaArrowRight } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import Home from './Home';
import Button from '../components/Button';

function Gallery() {
  const navigate = useNavigate();

  return (
    <div>
      <div className='hero-section'>
          <h1 className='hero-section-header'>Decor Delights & Events</h1>
          <h4 style={{ fontSize: '24px' }}>Luxury Event Planner</h4>
          <Button name="Contact Us" action={() => navigate("/contact")} />
      </div>

      <div className='images-container'>
        <div className='images'>
          <div className='gallery-image gallery-image-1'>
            <div className='gallery-description'>
              <p className='more-details-header'>Weddings, Bridal Showers and Anniversary Celebations</p>
              <p className='more-details-text' onClick={() => navigate('/weddings')}>Visit Gallery <FaArrowRight size={8}/></p>
            </div>
          </div>

          <div className='gallery-image gallery-image-2'> 
            <div className='gallery-description'>
              <p className='more-details-header'>Birthdays</p>
              <p className='more-details-text' onClick={() => navigate('/birthdays')}>Visit Gallery <FaArrowRight size={8}/></p>
            </div>
          </div>

          <div className='gallery-image gallery-image-3'>
            <div className='gallery-description'>
              <p className='more-details-header'>Graduations</p>
              <p className='more-details-text' onClick={() => navigate('/graduations')}>Visit Gallery <FaArrowRight size={8}/></p>
            </div>
          </div>

          <div className='gallery-image gallery-image-4'>
            <div className='gallery-description'>
              <p className='more-details-header'>Baby Showers</p>
              <p className='more-details-text' onClick={() => navigate('/babyshowers')}>Visit Gallery <FaArrowRight size={8}/></p>
            </div>
          </div>

          <div className='gallery-image gallery-image-5'>
            <div className='gallery-description'>
              <p className='more-details-header'>Gala and Corporate Events</p>
              <p className='more-details-text' onClick={() => navigate('/gala')}>Visit Gallery <FaArrowRight size={8}/></p>
            </div>
          </div>

        </div>
      </div>

      <Home />

    </div>
  )
}

export default Gallery